import { render, staticRenderFns } from "./AddedMediaTable.vue?vue&type=template&id=320772fd&scoped=true"
import script from "./AddedMediaTable.vue?vue&type=script&lang=js"
export * from "./AddedMediaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320772fd",
  null
  
)

export default component.exports